<template>
  <div class="payment__content">
    <!-- header -->
    <div class="layer__header">
      <div class="lyr-title">{{ $t('User.BellMobile.msg10') }}</div>
      <div class="ft-point">{{ $t('User.BellMobile.msg11') }}</div>
      <!-- <div class="lyr-txt">{{ $t('User.BellMobile.msg3') }}</div> -->
    </div>
    <!-- //header -->

    <div class="payment__body">
      <div class="inner-pd">
        <div class="input-text">{{ this.orgReciptData }}</div>
        <div class="keypad-wrap">
          <div class="keypad keypad--white">
            <button class="btn-anim" @mouseup="setRecipt(1)">1</button>
            <button class="btn-anim" @mouseup="setRecipt(2)">2</button>
            <button class="btn-anim" @mouseup="setRecipt(3)">3</button>
            <button class="btn-anim" @mouseup="setRecipt(4)">4</button>
            <button class="btn-anim" @mouseup="setRecipt(5)">5</button>
            <button class="btn-anim" @mouseup="setRecipt(6)">6</button>
            <button class="btn-anim" @mouseup="setRecipt(7)">7</button>
            <button class="btn-anim" @mouseup="setRecipt(8)">8</button>
            <button class="btn-anim" @mouseup="setRecipt(9)">9</button>
            <button @mouseup="setRecipt(10)" class="delete btn-anim">{{ $t('User.BellMobile.msg8') }}</button>
            <button class="btn-anim" @mouseup="setRecipt(0)">0</button>
            <button @mouseup="setRecipt(-1)" class="btn-back btn-anim">삭제</button>
          </div>
        </div>
        <!-- <div class="txt-tip center">{{ $t('User.BellMobile.msg9') }}</div> -->
      </div>
    </div>

    <div class="layer__button">
      <button class="btn btn--half btn--cancel btn-anim" v-if="useAlarmTalk" @mouseup="$emit('closePagerNumber')">{{ $t('User.BellMobile.msg6') }}</button>
      <button
        id="compBtn"
        class="btn btn--submit btn-anim"
        @mouseup="setPagerFinish"
        :class="[orgReciptData.length < 1 || orgReciptData === '00' ? 'btn--disabled' : 'btn--color']"
        :disabled="orgReciptData.length < 1 || orgReciptData === '00'"
      >
        {{ $t('User.BellMobile.msg7') }}
      </button>
    </div>
  </div>
</template>

<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'pagerNumber',
  props: {},
  data() {
    return {
      orgReciptData: '00',
      darkModeYn: this.$store.getters.getDarkModeYn,
      useAlarmTalk: this.$store.getters.getPosConfig.posConfig.useAlarmTalk,
      usePager: this.$store.getters.getPosConfig.posConfig.usePager,
    };
  },
  mounted() {},
  components: {},
  methods: {
    setRecipt(num) {
      if (num == 10) {
        this.orgReciptData = '';
      } else if (num < 0) {
        this.orgReciptData = this.orgReciptData.slice(0, -1);
      } else if (this.orgReciptData.length < 2) {
        this.orgReciptData += num + '';
      } else if (this.orgReciptData === '00') {
        this.orgReciptData = '';
        this.orgReciptData += num + '';
      }
    },
    setPagerFinish() {
      this.$logInfo(`Pager Finish PagerNum : ${this.orgReciptData}`);
      this.$emit('setPagerFinish', this.orgReciptData);
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
  .input-text {
    margin: 0px auto;
    width: 30vw;
    height: 11vh;
    line-height: 11vh;
    text-align: center;
    font-size: 9em;
    margin-bottom: 6.3vh;
  }

  .payment__body {
    height: 51vh;
  }
  
  .keypad-wrap {
    width: 39vw;
  }

  .keypad.keypad--white button {
    width: 11.2vw;
    height: 11.2vw;
  }
</style>
